module.exports = __webpack_public_path__ + "templates/report.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/auth/management/report/report.html
// module id = 369
// module chunks = 15